import { HttpHeaders } from '@angular/common/http';
import { API_DI_CONFIG } from '../../../app-config.module';
import { ApiParameters } from './api-parameters';
import { ApiRequestOptions } from './api-request-options';

/// TODO... Make a request factory.

export abstract class ApiBaseRequest
{
    protected readonly parameters: ApiParameters;
    protected readonly options: ApiRequestOptions;
    protected readonly service: string;
    protected readonly endpoint: string;

    public constructor(
        service: string,
        parameters: ApiParameters,
        options: ApiRequestOptions = null,
        endpoint: string = API_DI_CONFIG.api.core.endpoint
    )
    {
        if (options == null)
        {
            options = new ApiRequestOptions();
            options.headers = new HttpHeaders({
                'Content-Type': 'application/json'
            });
        }

        this.endpoint = endpoint;
        this.service = service;
        this.options = options;
        this.parameters = parameters || new ApiParameters();
    }

    public get Uri(): string
    {
        const query = this.parameters.getQueryString();
        if (query != null && query.length > 0)
        {
            return `${ this.endpoint }${ this.service }?${ query }`;
        }

        return `${ this.endpoint }${ this.service }`;
    }
}
